import { Dispatch, MutableRefObject, SetStateAction, useEffect, useState } from 'react'
import CoduleAccountTrading from '../coduleAccountTrading'
import { useRequest } from 'ahooks'
import { IResModuleTransactionRecord } from '@/api/account/interface'
import { getAccountModuleTransactionRecord } from '@/api/account'
import MeEmpty from '@/components/MeEmpty'
import LoadingCom from '@/components/LoadingCom'

interface IProps {
  address: string
  activeValue: string
  pageParams: {
    offset: number
    limit: number
  }
  setTotal: (total: number) => void
  setLoading: (loading: boolean) => void
  nextKey: MutableRefObject<string>
  setNextKeyData: Dispatch<SetStateAction<string>>
  offsetKey: MutableRefObject<string>
  keyArray: MutableRefObject<{
    [key: number]: string
  }>
  currentGroupIndex: MutableRefObject<number>
  offsetKeyArray: MutableRefObject<{
    [key: number]: string
  }>
  moduleTransitionCheckinTab: 'hub' | 'rollapp_checkin'
}
const DetailModuleAccountTransition = ({
  address,
  activeValue,
  pageParams,
  setTotal,
  setLoading,
  nextKey,
  setNextKeyData,
  offsetKey,
  keyArray,
  currentGroupIndex,
  offsetKeyArray,
  moduleTransitionCheckinTab,
}: IProps) => {
  const listParams = {
    address,
    limit: pageParams.limit,
    offset: pageParams.offset,
  }

  const [accountRecordList, setAccountRecordList] = useState<IResModuleTransactionRecord[]>([])

  const getPageParams = () => {
    const params: any = {
      offset: pageParams.offset,
      limit: pageParams.limit,
      address,
    }
    if (keyArray.current[currentGroupIndex.current]) {
      params.key = keyArray.current[currentGroupIndex.current]
    }
    if (offsetKeyArray.current[currentGroupIndex.current] && pageParams.offset > 0) {
      params.offset_key = offsetKeyArray.current[currentGroupIndex.current]
    }
    return params
  }

  const { loading, run } = useRequest(() => getAccountModuleTransactionRecord(getPageParams()), {
    manual: true,
    ready: false,
    onSuccess: (res) => {
      setAccountRecordList(res?.ModuleTransfer || [])
      setTotal(res?.group_count || 0)
      // 设置下一组key
      nextKey.current = res.next_key || ''
      setNextKeyData(res.next_key || '')
      offsetKeyArray.current[currentGroupIndex.current] = res.offset_key || ''
      // 设置当前组offsetKey
      offsetKey.current = res.offset_key || ''
    },
  })

  useEffect(() => {
    run()
  }, [pageParams, run, address, currentGroupIndex])

  useEffect(() => {
    setLoading(loading)
  }, [loading, setLoading])

  return (
    <>
      {activeValue === '1' && moduleTransitionCheckinTab === 'hub' && (
        <>
          {loading && <LoadingCom />}
          {!loading && accountRecordList.length === 0 && <MeEmpty />}
          {accountRecordList.map((item, index) => (
            <CoduleAccountTrading {...item} key={`${item.msg_index}${item.tx_hash}${index}`} />
          ))}
        </>
      )}
    </>
  )
}

export default DetailModuleAccountTransition
